import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var CylinderArbitraryIcon = function CylinderArbitraryIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsxs("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "CylinderArbitraryIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: [jsxs("g", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: ".9",
      strokeWidth: "1.45",
      clipPath: "url(#clip0_1217_61346)",
      children: [jsx("path", {
        d: "m1.872 8.471 5.657 5.657c.78.781 2.891-.063 4.714-1.885 1.822-1.823 2.666-3.933 1.885-4.714L8.471 1.872"
      }), jsx("path", {
        d: "M1.872 8.472c.185.185.455.284.792.29.338.005.736-.082 1.174-.257a7 7 0 0 0 1.377-.764c.472-.33.937-.722 1.37-1.155s.827-.899 1.156-1.37c.33-.472.589-.94.764-1.378s.262-.836.256-1.174c-.005-.337-.104-.606-.29-.792-.185-.186-.455-.284-.792-.29s-.736.081-1.174.256a7 7 0 0 0-1.377.764c-.472.33-.937.722-1.37 1.156s-.827.899-1.156 1.37c-.33.471-.589.94-.764 1.377s-.262.837-.256 1.174c.005.338.104.607.29.793"
      })]
    }), jsx("defs", {
      children: jsx("clipPath", {
        id: "clip0_1217_61346",
        children: jsx("path", {
          fill: "#fff",
          d: "M0 0h16v16H0z"
        })
      })
    })]
  }));
};

export { CylinderArbitraryIcon };
